import { useTranslation } from 'react-i18next';

interface IDictionaries {
  en?: Record<string, unknown>;
  id?: Record<string, unknown>;
}

interface IUseI18nNamespaceRegProp {
  dictionaries: IDictionaries;
  namespace: string;
  skipSetDefaultNamespace?: boolean;
}

export default function useI18nNamespaceReg({
  dictionaries,
  namespace,
  skipSetDefaultNamespace = false,
}: IUseI18nNamespaceRegProp) {
  const { i18n } = useTranslation();

  Object.keys(dictionaries).forEach((language: keyof typeof dictionaries) => {
    i18n.addResourceBundle(language, namespace, dictionaries[language]);
  });

  if (!skipSetDefaultNamespace) {
    i18n.setDefaultNamespace(namespace);
  }

  return useTranslation();
}
